"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _inlines = require("@canner/slate-constant/lib/inlines");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default(opt) {
  var options = Object.assign({
    type: _inlines.EMOJI,
    getEmoji: function getEmoji(node) {
      return node.data.getIn(["emoji", "native"]);
    }
  }, opt);
  return {
    // deserialize(el) {
    // TODO deserialize emoji
    // },
    serialize: function serialize(obj) {
      if (obj.object == "inline" && obj.type === options.type) {
        return _react.default.createElement("span", null, options.getEmoji(obj).trim());
      }
    }
  };
}